// In this folder, common variables can be accessed and edited in a single place.
export default {
  data() {
    return {
      // Name of the module defined in user rights. eg. blog for blog.edit, blog.add etc..
      permission: 'popup',
      // Where data is fetched from
      endpoint: 'popup',
      // The object key from the response object
      responseData: {
        single: 'popup',
        multiple: 'popups',
      },
      // Used for navigation on the front-end (matching the router)
      module: 'popups',
    };
  },
};
